module.exports = __webpack_public_path__ + "static/media/success.2f41046e.svg";